import PageBackBar from "@/components/PageBackBar";
import Services from "@/components/Services";
import { useSite } from "@/Layout";

export default function ServicesPage() {
  const { services, categoryNotes, vip, config } = useSite();
  return (
    <div data-testid="services-page">
      <PageBackBar testId="services-back-bar" />
      <Services
        services={services}
        categoryNotes={categoryNotes}
        vip={vip}
        config={config}
      />
    </div>
  );
}
